import { updateDiscordChannelApi } from "src/utils/api"
import type { SxTicketItem } from "src/contexts/DetailedSxBetslipContext"
import type { SxBetData } from "src/utils/sxDiscordHelper"
import { DiscordType } from "src/types/discord"
import type { Chain } from "viem"

const updateSxDiscordChannel = async (
  ticketItems: SxTicketItem[],
  betAmount: string,
  totalOdds: number,
  chain: Chain | undefined,
  txHash: string,
  betToken: string,
  // selectedCollateralSymbol: string,
  isLive?: boolean
) => {
  try {
    const updatedItems: SxBetData[] = ticketItems.map((item: SxTicketItem) => {
      return {
        marketHash: item.marketHash,
        outcome: item.outcome,
        percentageOdds: item.percentageOdds,
        outcomeOneName: item.outcomeOneName,
        outcomeTwoName: item.outcomeTwoName,
        isMakerBettingOutcomeOne: item.isMakerBettingOutcomeOne,
        marketName: item.marketName,
        chain: chain,
        txHash: txHash,
        game: item.game, // Use the actual game object structure from SX
        odds: item.odds,
        uniqueId: item.uniqueId || `${item.marketHash}-${Date.now()}`,
        baseToken: item.baseToken,
        gameLabel: item.game?.gameLabel || "",
        betAmount: betAmount,
        totalOdds: totalOdds,
        betToken: betToken,
        // selectedCollateralSymbol: selectedCollateralSymbol,
        live: isLive,
        allOdds: item.allOdds,
      }
    })

    const response = await updateDiscordChannelApi({
      items: updatedItems as any, // Type assertion needed as API expects flexible structure
      type: DiscordType.SX,
    })

    return response
  } catch (error) {
    const err = error as Error
    console.error("Error updating Discord channel for SX", err)
    throw err
  }
}

export default updateSxDiscordChannel
